import {MuWidget} from "mu-widget/lib/MuWidget";
import {UiTomSelect} from "./UiTomSelect";
import {TomOption} from "tom-select/dist/types/types";
import {UiDms} from "../dms/UiDms";
import {UiBuSubjectEditor} from "../dms/UiBuSubjectEditor";
import {BaseSelector} from "./BaseSelector";

export class UiAccountSelector extends UiTomSelect
{
	beforeIndex() {
		super.beforeIndex();
		this.muAppendContent(`<div mu-template="item" mu-widget=".">
				<strong mu-bind="name"></strong>
				<em mu-bind="orgDivisionCode"></em>
			</div>`
		);
	}

	afterIndex() {
		this.optionLoader = async (query, callback) => {
			const res: TomOption[] = await UiDms.instance.cl.findAccounts(query);
			callback(res, []);
		}
		this.init();
	}

	/* createNew_click() {
		const bse = UiDms.instance.openInModal<UiBuSubjectEditor>("UiBuSubjectEditor", "Přidat subjekt");
		bse.savedPromise.then((ev) => {
			console.log(ev)
		});
	} */
}
export class UiAccountSelector_old extends MuWidget
{
	beforeIndex() {
		this.muAppendContent(`<div mu-widget="UiTomSelect" mu-id="input">
			<div mu-template="item" mu-widget=".">
				<strong mu-bind="name"></strong>
				<em mu-bind="orgDivisionCode"></em>
			</div>
			</div>`
		);
	}

	afterIndex() {
		const tom = (this.muNamedWidget.input as unknown as UiTomSelect);
		tom.optionLoader = async (query, callback) => {
			const res: TomOption[] = await UiDms.instance.cl.findAccounts(query);
			callback(res, []);
		}
		tom.init();
	}

	createNew_click() {
		// @ts-ignore
		const bse = UiDms.instance.openInModal<UiBuSubjectEditor>("UiBuSubjectEditor", "Přidat subjekt");
	}
}